import landingPage from '@/views/loginModule/login.vue';

export default [
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      const isLoggedIn = !!localStorage.getItem('token');
      if (isLoggedIn) {
        next({ name: 'dashboard' });
      } else {
        next();
      }
    },
    component: landingPage,
  }
]